import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-custact-works',
  templateUrl: './custact-works.component.html',
  styleUrls: ['./custact-works.component.css']
})
export class CustactWorksComponent implements OnInit {
    custactNo;

    public setting?: Setting;

    public itemsListJobs: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
    }

    private async loadSetting() {
        if (!!this.custactNo) {
            this.setting = (await this.datatask.Post(28, { custact_no: this.custactNo }))[0];
        }
    }

    private async loadJobs() {
        if (!this.setting) return;

        return this.itemsListJobs = await this.datatask.Post(377, { custact_no: this.setting.custact_no });
    }

    private async init() {
        await this.loadSetting();
        this.loadJobs();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    custact_no: string;
    custactinfotext: string;
}
